var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Guard Config")]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2", md: "2" } },
                    [
                      _c("r-range", {
                        attrs: { model: _vm.model.level, label: "Level:" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "level", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c("r-guard-rules", {
                    attrs: {
                      items: _vm.model.allow,
                      anyof: _vm.model.allowAnyOf,
                      title: "Allow",
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "allow", $event)
                      },
                      "update:anyof": function ($event) {
                        return _vm.$set(_vm.model, "allowAnyOf", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("r-guard-rules", {
                    attrs: {
                      items: _vm.model.block,
                      anyof: _vm.model.blockAnyOf,
                      title: "Block",
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "block", $event)
                      },
                      "update:anyof": function ($event) {
                        return _vm.$set(_vm.model, "blockAnyOf", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
              _c(
                "v-row",
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      !_vm.isEmptyArray(_vm.model.offersAllow)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: { small: "", color: "success" },
                              on: { click: _vm.onOffersAllow },
                            },
                            [_vm._v(" Offers Allow ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: { click: _vm.onOffersAllow },
                            },
                            [_vm._v(" Offers Allow ")]
                          ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      !_vm.isEmptyArray(_vm.model.offersBlock)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: { small: "", color: "success" },
                              on: { click: _vm.onOffersBlock },
                            },
                            [_vm._v(" Offers Block ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: { click: _vm.onOffersBlock },
                            },
                            [_vm._v(" Offers Block ")]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
      _c("r-smart-offer-table-dialog", { ref: "smart-offer-table-dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }